import lazyLoad from 'app/shared-components/util/lazyLoad';

const ContactsApp = lazyLoad(() => import('./ContactsApp'));

const ContactsAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  helpConfig: {
    query: 'network contacts',
    tag: 'network',
    title: 'Network'
  },
  routes: [
    {
      path: 'apps/network',
      element: <ContactsApp />,
      children: [
        {
          path: 'view/:id',
          element: <div/>,
        },
      ],
    },
    {
      path: 'apps/network/:filter',
      element: <ContactsApp />,
      children: [
        {
          path: 'view/:id',
          element: <div/>,
        },
      ],
    }
  ],
};

export default ContactsAppConfig;
